import { render, staticRenderFns } from "./InformarEntrega.vue?vue&type=template&id=0cb65c28&"
import script from "./InformarEntrega.vue?vue&type=script&lang=js&"
export * from "./InformarEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports